var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBookingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24445 0.151972C9.40195 0.0583117 9.59806 0.0583046 9.75556 0.151954L18.7555 5.50331C18.9071 5.59343 19 5.75673 19 5.93307V16.6616C19 16.8379 18.9071 17.0012 18.7555 17.0913L11.2555 21.5508C10.9222 21.7489 10.5 21.5088 10.5 21.121V10.9892C10.5 10.8128 10.4071 10.6495 10.2555 10.5594L1.72085 5.48578C1.39488 5.292 1.39484 4.82007 1.72078 4.62624L9.24445 0.151972ZM0.755536 7.28514C0.422244 7.08697 0 7.32715 0 7.71491V16.6616C0 16.8379 0.0928909 17.0012 0.244464 17.0913L7.74446 21.5508C8.07776 21.7489 8.5 21.5088 8.5 21.121V12.1743C8.5 11.998 8.40711 11.8347 8.25554 11.7446L0.755536 7.28514Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookingsIcon);
export default __webpack_public_path__ + "static/media/MyBookingsIcon.99f25f2b2f7d4a19573f0998341c6bb2.svg";
export { ForwardRef as ReactComponent };